import { useTranslation } from 'react-i18next';
import { PayoutsContainer } from '@/features/payouts';
import { Button } from '@/components/atoms/button';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function WalletPayoutsPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Link to="/wallet">
          <Button variant="ghost" size="icon">
            <ArrowLeft className="size-5" />
          </Button>
        </Link>
        <h1 className="text-2xl font-bold tracking-tight">{t('payouts.title')}</h1>
      </div>
      <PayoutsContainer />
    </div>
  );
}
